module.exports = __webpack_public_path__ + "static/media/b2c.423ea3af.png";